export const ITEMS_PER_PAGE = 10;
export const INITIAL_PAGE_NUMBER = 1;
export const MAX_VISIBLE_PAGES = 5;
export const NEXT_LABEL = 'Next';
export const PREVIOUS_LABEL = 'Previous';
export const PAGINATION_LABEL = 'Label';
export const RESULTS_PER_PAGE_LABEL = 'Items per page';
export const ROWS_PER_PAGE_LABEL_CONTENT = 'Showing';
export const PAGE_LABEL = 'Page';
export const ERROR_MESSAGE = 'Enter a valid number.';
export const CHECK_FOR_NO_STRING_LITERAL = 'NO';
export const MAX_VISIBLIE_ITEMS = 5;

export const INITIAL_PAGE_INDEX = 1;
export const VISIBLE_PAGES = 5;
export const ROWS_PER_PAGE = [10, 20, 30, 40];

/**
 * The text displayed on the filter button.
 */
export const FILTER_BUTTON_TEXT = 'Filters';
/**
 * ARIA label for the filter button.
 */
export const FILTER_BUTTON_TEXT_ARIA_LABEL = 'Apply Filters';

/**
 * The title for the filter modal in the file download experience.
 * Use this constant to display the title of the modal when selecting category filters.
 * The filters will enhance the search results.
 */
export const FILTER_MODAL_TITLE =
  'Select category filters to enhance your search results.';

/**
 * ARIA label for the close button in the filter modal.
 */
export const FILTER_MODAL_CLOSE_ARIA_LABEL = 'Close Modal';

export const FILTER_MODAL_Filter_BY = 'Filter by:';

export const FILTER_MODAL_CLEAR_BUTTON_TEXT = 'Clear filters';

export const FILTER_MODAL_CLEAR_ARIA_LABEL = 'Clear all filters';

export const FILTER_MODAL_CANCEL_BUTTON_TEXT = 'Cancel';

export const FILTER_MODAL_APPLY_BUTTON_TEXT = 'Apply Filters';

export const PAGINATION_CONFIG = {
  '10': 5,
  '20': 4,
  '30': 3,
  '40': 2,
};

export const DESKTOP_MIN_WIDTH = 768;

export const MOBILE_MAX_WIDTH = DESKTOP_MIN_WIDTH + 1;

export const HTML_MESSAGE =
  '<p>Replace this <a href="https://example.com" target="_blank"> message  </a> with author content</p>';
